/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-16 11:14:43
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-11-04 15:08:36
 * @FilePath: /unifyxp-v2-store-portal/src/components/FieldModal/config.ts
 */
import { EnumFieldType, nameDict as n } from 'src/types/common/customerDb';
enum Type {
  Input = 'Input',
  Selector = 'Selector',
}

enum SelectorType {
  Single = 'Single',
  Multiple = 'Multiple',
}

const typeDisplayName = {
  [Type.Input]: 'Input Field',
  [Type.Selector]: 'Selector',
};

const types: EnumFieldType[] = [
  EnumFieldType.FullName,
  EnumFieldType.FirstName,
  EnumFieldType.LastName,
  EnumFieldType.PhoneNumber,
  EnumFieldType.DateOfBirth,
  EnumFieldType.Gender,
  EnumFieldType.Title,
  EnumFieldType.Email,
  // EnumFieldType.CompanyName,
  // EnumFieldType.InterestedProduct,

  //EnumFieldType.PreferredLanguage,
  // EnumFieldType.CountryRegion,
  // EnumFieldType.Postcode,
  //EnumFieldType.Address,
];

const nameDict = {
  [EnumFieldType.FirstName]: {
    defaultValue: n[EnumFieldType.FirstName],
    type: Type.Input,
  },
  [EnumFieldType.LastName]: {
    defaultValue: n[EnumFieldType.LastName],
    type: Type.Input,
  },
  [EnumFieldType.FullName]: {
    defaultValue: n[EnumFieldType.FullName],
    type: Type.Input,
  },
  [EnumFieldType.DateOfBirth]: {
    defaultValue: n[EnumFieldType.DateOfBirth],
    type: Type.Input,
  },
  [EnumFieldType.Gender]: {
    defaultValue: n[EnumFieldType.Gender],
    type: Type.Selector,
  },
  [EnumFieldType.Title]: {
    defaultValue: n[EnumFieldType.Title],
    type: Type.Selector,
  },
  [EnumFieldType.Email]: {
    defaultValue: n[EnumFieldType.Email],
    type: Type.Input,
  },
  [EnumFieldType.PhoneNumber]: {
    defaultValue: n[EnumFieldType.PhoneNumber],
    type: Type.Input,
  },
  [EnumFieldType.MobileNumber]: {
    defaultValue: n[EnumFieldType.MobileNumber],
    type: Type.Input,
  },
  [EnumFieldType.AreaCodeMobileNumber]: {
    defaultValue: n[EnumFieldType.AreaCodeMobileNumber],
    type: Type.Input,
  },
};
export { types, nameDict, EnumFieldType, typeDisplayName, Type, SelectorType };
